/* =========================================================
   Coveo "Pick any 3" bundle (Oct 2026)
   One picker for three places:
   1. The homepage block   [data-cv-bundle][data-mode="home"]
   2. The product page     [data-cv-bundle][data-mode="pdp"]   (this case is slot 1)
   3. The bag nudge        [data-cv-bundle-open][data-count]   (adds the missing cases)
   The cases come from the bundle collection (window.CoveoBundle.url + /products.json).
   The price comes from the automatic discount in Shopify, not from this file.
   Settings (size, price, collection) live in the "Coveo brand files" section.
   ========================================================= */
(function () {
  'use strict';
  if (window.__coveoBundle) return;
  window.__coveoBundle = true;

  var B = window.CoveoBundle || {};
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SIZE = Number(B.size) || 3;
  var PRICE = Number(B.price) || 3999;
  var URL = B.url || '/collections/bundle';
  var lastModel = null;
  var catalog = null;
  var loading = null;

  function money(cents) {
    var f = B.moneyFormat || '${{amount}}';
    return f.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/<[^>]*>/g, '');
  }
  var PRICE_TEXT = B.priceText || money(PRICE);
  // Next step, "4 for $50" (second discount in Shopify). Shown as a small line on the blocks and as a step in the bag.
  var UP = B.up && Number(B.up.size) > SIZE ? { size: Number(B.up.size), price: Number(B.up.price), text: B.up.priceText || money(Number(B.up.price)) } : null;
  var THRESHOLD = (window.CoveoConfig && Number(window.CoveoConfig.threshold)) || 4999;
  function priceFor(n) { return UP && n >= UP.size ? UP.text : PRICE_TEXT; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function sized(src, w) { if (!src) return null; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function shortName(t) { return String(t).replace(/\s+Case$/i, ''); }
  function modelIndex(p) {
    for (var i = 0; i < p.options.length; i++) { if (/model|device/i.test(p.options[i].name)) return i; }
    return -1;
  }
  function fill(str, map) { return String(str).replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; }); }

  /* ---------- the cases ---------- */
  function load() {
    if (catalog) return Promise.resolve(catalog);
    if (loading) return loading;
    loading = fetch(URL + '/products.json?limit=50', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        catalog = (j.products || []).map(function (p) {
          var opts = (p.options || []).map(function (o) { return { name: o.name, values: o.values }; });
          var single = p.variants.length === 1 && /^default title$/i.test(p.variants[0].title || '');
          var variants = p.variants.map(function (v) {
            return {
              id: v.id,
              o: [v.option1, v.option2, v.option3].slice(0, opts.length),
              a: !!v.available,
              p: Math.round(parseFloat(v.price) * 100),
              img: v.featured_image ? sized(v.featured_image.src, 400) : null
            };
          });
          return {
            id: p.id,
            title: p.title,
            image: p.images && p.images[0] ? sized(p.images[0].src, 400) : null,
            available: variants.some(function (v) { return v.a; }),
            options: opts,
            variants: variants,
            single: single
          };
        });
        return catalog;
      })
      .catch(function (e) { loading = null; throw e; });
    return loading;
  }
  function findProduct(id) { return (catalog || []).filter(function (p) { return String(p.id) === String(id); })[0] || null; }
  function findVariantById(p, id) { return p ? p.variants.filter(function (v) { return String(v.id) === String(id); })[0] || null : null; }
  function regularFor(picks) {
    var base = catalog && catalog.length ? catalog[0].variants[0].p : 1499;
    var total = 0;
    for (var i = 0; i < SIZE; i++) total += picks[i] ? picks[i].v.p : base;
    return total;
  }

  /* ---------- add to the bag and open it ---------- */
  function addItems(variantIds) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: variantIds.map(function (id) { return { id: id, quantity: 1 }; }) };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok || d.status) throw new Error(d.description || d.message || 'add'); return d; });
    }).then(function (res) {
      if (!(drawer && typeof drawer.renderContents === 'function' && res.sections)) { window.location.href = ROOT + 'cart'; return res; }
      drawer.classList.remove('is-empty');
      drawer.renderContents(res);
      // coveo.js adds the free charger wrap and redraws the bag with the bundle price
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'coveo-bundle', cartData: res });
      }
      return res;
    });
  }

  /* ---------- the picker (one for the whole page) ---------- */
  var modal = null, panel = null, ctx = null, step = null, opener = null;

  function ensureModal() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'cv-bpick';
    modal.hidden = true;
    modal.innerHTML = '<div class="cv-bpick__shade" data-cv-bclose></div>' +
      '<div class="cv-bpick__panel" role="dialog" aria-modal="true" aria-labelledby="CvBpickTitle" tabindex="-1"></div>';
    document.body.appendChild(modal);
    panel = modal.querySelector('.cv-bpick__panel');
    modal.addEventListener('click', onModalClick);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) closePicker(); });
  }

  function head(title, sub, back) {
    return '<div class="cv-bpick__head">' +
      (back ? '<button type="button" class="cv-bpick__back" data-cv-bback aria-label="Back to all cases">&#8249;</button>' : '') +
      '<div class="cv-bpick__headtext"><p class="cv-bpick__title" id="CvBpickTitle">' + esc(title) + '</p>' +
      (sub ? '<span class="cv-bpick__count">' + esc(sub) + '</span>' : '') + '</div>' +
      '<button type="button" class="cv-bpick__close" data-cv-bclose aria-label="Close">&times;</button></div>';
  }

  function renderLoading() {
    panel.innerHTML = head(ctx.title(), '', false) + '<div class="cv-bpick__body"><p class="cv-bpick__wait">Loading the cases…</p></div>';
  }
  function renderError() {
    panel.innerHTML = head(ctx.title(), '', false) + '<div class="cv-bpick__body"><p class="cv-bpick__wait">The cases could not load. Please try again.</p></div>';
  }

  function renderGrid() {
    step = null;
    var html = head(ctx.title(), ctx.sub(), false) + '<div class="cv-bpick__body"><div class="cv-bpick__grid">';
    catalog.forEach(function (p, i) {
      var out = !p.available;
      html += '<button type="button" class="cv-bcase' + (out ? ' is-out' : '') + '" data-cv-bcase="' + i + '"' + (out ? ' disabled' : '') + '>' +
        (p.image ? '<img class="cv-bcase__img" src="' + esc(p.image) + '" alt="" loading="lazy">' : '<span class="cv-bcase__img"></span>') +
        '<span class="cv-bcase__name">' + esc(shortName(p.title)) + (out ? ' · sold out' : '') + '</span></button>';
    });
    html += '</div></div>';
    panel.innerHTML = html;
    panel.scrollTop = 0;
  }

  function stepVariant() {
    if (!step) return null;
    var p = step.p;
    if (p.single || p.variants.length === 1) return p.variants[0];
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i], ok = true;
      for (var j = 0; j < p.options.length; j++) { if (v.o[j] !== step.pick[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }
  function valueAvailable(oi, val) {
    return step.p.variants.some(function (v) {
      if (!v.a || v.o[oi] !== val) return false;
      for (var j = 0; j < step.p.options.length; j++) { if (j !== oi && step.pick[j] != null && v.o[j] !== step.pick[j]) return false; }
      return true;
    });
  }
  function renderOptions() {
    var p = step.p, v = stepVariant();
    var img = (v && v.img) || p.image;
    var html = head(ctx.title(), '', true) + '<div class="cv-bpick__body">' +
      '<div class="cv-bpick__pick">' + (img ? '<img src="' + esc(img) + '" alt="">' : '<span></span>') +
      '<p class="cv-bpick__pickname">' + esc(p.title) + '</p></div>';
    if (!(p.single || p.variants.length === 1)) {
      p.options.forEach(function (o, i) {
        html += '<div class="cv-bpick__opt"><p class="cv-bpick__label">' + esc(o.name) + (step.pick[i] != null ? '<b>' + esc(step.pick[i]) + '</b>' : '') + '</p><div class="cv-bpick__chips">';
        o.values.forEach(function (val) {
          var on = step.pick[i] === val, avail = valueAvailable(i, val);
          html += '<button type="button" class="cv-bchip' + (avail ? '' : ' is-out') + '" aria-pressed="' + on + '"' + (avail ? '' : ' disabled') +
            ' data-cv-bopt="' + i + '" data-cv-bval="' + esc(val) + '">' + esc(val) + '</button>';
        });
        html += '</div></div>';
      });
    }
    var ready = v && v.a;
    var missing = '';
    if (!ready) p.options.forEach(function (o, i) { if (!missing && step.pick[i] == null) missing = o.name.toLowerCase(); });
    html += '<button type="button" class="cv-bpick__add" data-cv-bput' + (ready ? '' : ' disabled') + '>' +
      esc(ready ? ctx.putText() : (missing ? 'Choose ' + missing : 'Sold out')) + '</button></div>';
    panel.innerHTML = html;
  }
  function choose(p) {
    var pick = p.options.map(function () { return null; });
    var mi = modelIndex(p);
    if (mi > -1 && lastModel && p.options[mi].values.indexOf(lastModel) > -1) pick[mi] = lastModel;
    p.options.forEach(function (o, i) { if (pick[i] == null && o.values.length === 1) pick[i] = o.values[0]; });
    step = { p: p, pick: pick };
    if (mi > -1 && pick[mi] != null && !valueAvailable(mi, pick[mi])) step.pick[mi] = null;
    renderOptions();
  }

  function openPicker(context, from) {
    ensureModal();
    ctx = context;
    opener = from || null;
    modal.hidden = false;
    document.documentElement.classList.add('cv-bpick-open');
    if (catalog) renderGrid(); else { renderLoading(); load().then(function () { if (ctx === context) renderGrid(); }, function () { if (ctx === context) renderError(); }); }
    panel.focus();
  }
  function closePicker() {
    if (!modal) return;
    modal.hidden = true;
    step = null;
    document.documentElement.classList.remove('cv-bpick-open');
    var c = ctx; ctx = null;
    if (c && c.closed) c.closed();
    if (opener && document.contains(opener)) opener.focus();
  }

  function onModalClick(e) {
    var t = e.target instanceof Element ? e.target : null;
    if (!t || !ctx) return;
    if (t.closest('[data-cv-bclose]')) { closePicker(); return; }
    if (t.closest('[data-cv-bback]')) { renderGrid(); return; }
    var c = t.closest('[data-cv-bcase]');
    if (c && !c.disabled) { choose(catalog[Number(c.getAttribute('data-cv-bcase'))]); return; }
    var chip = t.closest('[data-cv-bopt]');
    if (chip && step) {
      var i = Number(chip.getAttribute('data-cv-bopt')), val = chip.getAttribute('data-cv-bval');
      step.pick[i] = step.pick[i] === val ? null : val;
      renderOptions();
      var again = panel.querySelector('[data-cv-bopt="' + i + '"][data-cv-bval="' + CSS.escape(val) + '"]');
      if (again) again.focus();
      return;
    }
    if (t.closest('[data-cv-bput]') && step) {
      var v = stepVariant();
      if (!v || !v.a) return;
      var mi = modelIndex(step.p);
      if (mi > -1) lastModel = v.o[mi];
      var next = ctx.put(step.p, v);
      if (next) renderGrid(); else closePicker();
    }
  }

  /* ---------- a builder block (homepage or product page) ---------- */
  function Builder(root) {
    this.root = root;
    this.mode = root.getAttribute('data-mode') || 'home';
    this.picks = [];
    this.lock = this.mode === 'pdp';
    this.slotsEl = root.querySelector('[data-cv-bundle-slots]');
    this.barEl = root.querySelector('[data-cv-bundle-bar]');
    this.btn = root.querySelector('[data-cv-bundle-btn]');
    this.err = root.querySelector('[data-cv-bundle-error]');
    this.text = {
      start: root.getAttribute('data-text-start') || 'Build my bundle',
      next: root.getAttribute('data-text-next') || 'Pick case {n}',
      more: root.getAttribute('data-text-more') || 'Pick {left} more',
      done: root.getAttribute('data-text-done') || 'Add {size} to bag · {price}'
    };
    var self = this;
    root.querySelectorAll('[data-cv-bundle-headline]').forEach(function (el) {
      el.textContent = fill(el.getAttribute('data-cv-bundle-headline') || 'Make it {size} for {price}', { size: SIZE, price: PRICE_TEXT });
    });
    this.buildSlots();
    if (UP && this.barEl && !root.querySelector('.cv-bundle__up')) {
      var up = document.createElement('p');
      up.className = 'cv-bundle__up';
      up.textContent = 'Or make it ' + UP.size + ' for ' + UP.text + (UP.price >= THRESHOLD ? ', delivery free.' : '.');
      this.barEl.insertAdjacentElement('afterend', up);
    }
    this.paint();
    root.addEventListener('click', function (e) { self.onClick(e); });
    if (this.lock) {
      load().then(function () { self.syncSelf(); });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
          var v = ev && ev.data && ev.data.variant;
          self.syncSelf(v ? v.id : null);
        });
      }
    }
  }
  Builder.prototype.buildSlots = function () {
    var html = '';
    for (var i = 0; i < SIZE; i++) {
      html += '<button type="button" class="cv-slot" data-cv-slot="' + i + '" aria-label="Choose case ' + (i + 1) + '">' +
        '<span class="cv-slot__ring"><span class="cv-slot__plus" aria-hidden="true">+</span></span>' +
        '<span class="cv-slot__label">Case ' + (i + 1) + '</span></button>';
    }
    this.slotsEl.innerHTML = html;
    this.slotsEl.style.setProperty('--cv-size', SIZE);
  };
  Builder.prototype.pageVariantId = function () {
    var input = document.querySelector('product-form input[name="id"], form[data-type="add-to-cart-form"] input[name="id"]');
    return input ? input.value : null;
  };
  Builder.prototype.syncSelf = function (variantId) {
    var p = findProduct(this.root.getAttribute('data-product-id'));
    var v = findVariantById(p, variantId || this.pageVariantId());
    this.picks[0] = p && v && v.a ? { p: p, v: v, locked: true } : null;
    if (p && v) { var mi = modelIndex(p); if (mi > -1) lastModel = v.o[mi]; }
    this.paint();
  };
  Builder.prototype.count = function () { return this.picks.filter(Boolean).length; };
  Builder.prototype.nextEmpty = function () { for (var i = 0; i < SIZE; i++) { if (!this.picks[i]) return i; } return -1; };
  Builder.prototype.paint = function () {
    var self = this;
    this.slotsEl.querySelectorAll('[data-cv-slot]').forEach(function (s, i) {
      var pk = self.picks[i];
      s.classList.toggle('is-full', !!pk);
      s.classList.toggle('is-locked', !!(pk && pk.locked));
      var ring = s.querySelector('.cv-slot__ring');
      var label = s.querySelector('.cv-slot__label');
      var model = s.querySelector('.cv-slot__model');
      var x = s.querySelector('.cv-slot__x');
      if (pk) {
        var src = pk.v.img || pk.p.image;
        var img = ring.querySelector('img');
        if (!img || img.getAttribute('data-id') !== String(pk.v.id)) {
          ring.innerHTML = src ? '<img class="cv-slot__img" src="' + esc(src) + '" alt="" data-id="' + pk.v.id + '">' : '';
        }
        label.textContent = pk.locked ? 'This case' : shortName(pk.p.title);
        if (!model) { model = document.createElement('span'); model.className = 'cv-slot__model'; s.appendChild(model); }
        model.textContent = pk.p.variants.length > 1 ? pk.v.o.join(' · ') : '';
        if (!pk.locked && !x) { x = document.createElement('span'); x.className = 'cv-slot__x'; x.setAttribute('data-cv-remove', i); x.setAttribute('aria-hidden', 'true'); x.textContent = '×'; s.appendChild(x); }
        if (pk.locked && x) x.remove();
        s.setAttribute('aria-label', pk.locked ? 'Case 1: this case' : 'Case ' + (i + 1) + ': ' + pk.p.title + '. Tap to change.');
      } else {
        ring.innerHTML = '<span class="cv-slot__plus" aria-hidden="true">+</span>';
        label.textContent = 'Case ' + (i + 1);
        if (model) model.remove();
        if (x) x.remove();
        s.setAttribute('aria-label', 'Choose case ' + (i + 1));
      }
    });
    var n = this.count();
    if (this.barEl) {
      var regular = regularFor(this.picks);
      var save = regular - PRICE;
      this.barEl.innerHTML = '<span>' + SIZE + ' cases · ' + esc(PRICE_TEXT) + (save > 0 ? '<s>' + money(regular) + '</s>' : '') + '</span>' +
        '<span class="cv-bundle__save">' + (save > 0 ? 'You save ' + money(save) : '') + '</span>';
    }
    var map = { n: n + 1, left: SIZE - n, size: SIZE, price: PRICE_TEXT };
    if (n >= SIZE) this.btn.textContent = fill(this.text.done, map);
    else if (this.lock && n > 0) this.btn.textContent = fill(this.text.more, map);
    else if (n === 0) this.btn.textContent = this.text.start;
    else this.btn.textContent = fill(this.text.next, map);
    if (this.err) this.err.hidden = true;
  };
  Builder.prototype.open = function (slot, from) {
    var self = this;
    this.active = slot;
    openPicker({
      title: function () { return 'Pick case ' + (self.active + 1); },
      sub: function () { return self.count() + ' of ' + SIZE + ' picked'; },
      putText: function () { return 'Put in case ' + (self.active + 1); },
      put: function (p, v) {
        self.picks[self.active] = { p: p, v: v };
        self.paint();
        var next = self.nextEmpty();
        if (next > -1) { self.active = next; return true; }
        return false;
      }
    }, from);
  };
  Builder.prototype.addAll = function () {
    var self = this;
    var ids = this.picks.map(function (pk) { return pk.v.id; });
    this.btn.disabled = true;
    this.btn.textContent = '…';
    addItems(ids).then(function () {
      self.btn.disabled = false;
      self.picks = self.lock ? [self.picks[0]] : [];
      self.paint();
    }).catch(function (err) {
      self.btn.disabled = false;
      self.paint();
      if (self.err) {
        self.err.textContent = (err && err.message && err.message !== 'add') ? err.message : 'Something went wrong. Please try again.';
        self.err.hidden = false;
      }
    });
  };
  Builder.prototype.onClick = function (e) {
    var t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    var rm = t.closest('[data-cv-remove]');
    if (rm) { e.preventDefault(); e.stopPropagation(); this.picks[Number(rm.getAttribute('data-cv-remove'))] = null; this.paint(); return; }
    var s = t.closest('[data-cv-slot]');
    if (s) {
      var i = Number(s.getAttribute('data-cv-slot'));
      if (this.picks[i] && this.picks[i].locked) return;
      this.open(i, s);
      return;
    }
    if (t.closest('[data-cv-bundle-btn]')) {
      var next = this.nextEmpty();
      if (next > -1) this.open(next, this.btn);
      else this.addAll();
    }
  };

  /* ---------- from the bag: pick the missing cases ---------- */
  function completeFromBag(have, target, from) {
    var goal = Math.max(SIZE, Number(target) || SIZE);
    var need = Math.max(1, goal - have);
    var picks = [];
    openPicker({
      title: function () { return 'Pick case ' + (have + picks.length + 1) + ' of ' + goal; },
      sub: function () { return have + picks.length + ' of ' + goal + ' in your bag'; },
      putText: function () { return picks.length + 1 >= need ? 'Add to bag · ' + priceFor(goal) + ' for ' + goal : 'Next case'; },
      put: function (p, v) {
        picks.push(v.id);
        if (picks.length < need) return true;
        addItems(picks).catch(function () { window.location.href = ROOT + 'cart'; });
        return false;
      }
    }, from);
  }

  /* ---------- start ---------- */
  function start() {
    document.querySelectorAll('[data-cv-bundle]').forEach(function (el) {
      if (el.__cvBundle) return;
      el.__cvBundle = true;
      new Builder(el);
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target instanceof Element ? e.target.closest('[data-cv-bundle-open]') : null;
    if (!t) return;
    e.preventDefault();
    completeFromBag(Number(t.getAttribute('data-count')) || 0, Number(t.getAttribute('data-target')) || SIZE, t);
  });
  // Warm up the list a moment after the page loads, so the picker opens instantly.
  window.addEventListener('load', function () { setTimeout(function () { load().catch(function () {}); }, 1500); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  // Theme editor: when a section is clicked or a setting changes, Shopify redraws it as fresh HTML
  // (empty slots, empty price bar), so set up the new copy again.
  document.addEventListener('shopify:section:load', start);
  window.CoveoBundleStart = start;
})();
